import { render, staticRenderFns } from "./ProdutosPrevisul.vue?vue&type=template&id=0b36fb20"
import script from "./ProdutosPrevisul.vue?vue&type=script&lang=js"
export * from "./ProdutosPrevisul.vue?vue&type=script&lang=js"
import style0 from "./ProdutosPrevisul.vue?vue&type=style&index=0&id=0b36fb20&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports